"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
var owa_options_controls_1 = require("owa-options-controls");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var React = require("react");
var store_1 = require("../data/store/store");
var owa_session_store_1 = require("owa-session-store");
var selectLocaleOption_1 = require("../data/mutators/selectLocaleOption");
var setRenameFoldersOption_1 = require("../data/mutators/setRenameFoldersOption");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var styles = require('./Regional.scss');
var CultureSelection = /** @class */ (function (_super) {
    tslib_1.__extends(CultureSelection, _super);
    function CultureSelection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CultureSelection.prototype.render = function () {
        var store = store_1.default();
        return (React.createElement("div", null,
            React.createElement(Dropdown_1.Dropdown, { label: owa_options_strings_1.default.option_regional_language, options: store.supportedCultures.map(function (culture) { return ({
                    text: culture.NativeName,
                    key: culture.Name,
                }); }), selectedKey: store.selectedLocale || owa_session_store_1.getUserConfiguration().SessionSettings.UserCulture, onChanged: this.onSelectLocale }),
            store.selectedLocale !== null &&
                store.selectedLocale !== owa_session_store_1.getUserConfiguration().SessionSettings.UserCulture && (React.createElement(owa_options_controls_1.OptionsCheckbox, { className: styles.renameFolders, onChange: this.toggleRenameFolders, label: owa_options_strings_1.default.option_regional_renameDefaultFolders, checked: store.shouldRenameDefaultFolders })),
            store.hasUserChangedLanguage && (React.createElement(Button_1.CommandButton, { text: owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-localeHotReload')
                    ? owa_options_strings_1.default.option_regional_languageHotReload
                    : owa_options_strings_1.default.option_regional_languageReload, onClick: this.reloadPage, className: styles.reloadButton }))));
    };
    CultureSelection.prototype.toggleRenameFolders = function (ev, checked) {
        setRenameFoldersOption_1.default(checked);
    };
    CultureSelection.prototype.reloadPage = function () {
        location.reload();
    };
    CultureSelection.prototype.onSelectLocale = function (item) {
        selectLocaleOption_1.default(item.key);
    };
    CultureSelection = tslib_1.__decorate([
        mobx_react_1.observer
    ], CultureSelection);
    return CultureSelection;
}(React.Component));
exports.default = CultureSelection;
//# sourceMappingURL=CultureSelection.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/view/CultureSelection.js
// module id = 4927
// module chunks = 2